module.exports = __webpack_public_path__ + "img/convert-to-case-inactive.a4802b4a.svg";